<template>
  <div style="width: 100%">
    <fieldset v-for="attributeInfo in attributeList" class="tags">
      <legend>{{ attributeInfo.type_name }}</legend>
      <div
        class="tag"
        v-on:click="toggle(attribute)"
        v-for="attribute in attributeInfo.attributes"
        v-bind:class="{ active: isSelected(attribute)}">
        {{ formatAttributeName(attribute) }}
      </div>
    </fieldset>
  </div>
</template>

<style lang="less" scoped>
.tags {
  margin-bottom: 5px;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  .tag {
    font-size: 14px;
    font-weight: normal;
    cursor: pointer;
    margin-bottom:5px;
    &.active {
      background: #2f3239;
      color: #fff;
    }
    &:hover {
      background: #ccc;
      color: #000;
    }
    text-transform: none;
    display: flex;
  }
  legend {
    font-weight: bold;
    text-transform: uppercase;
  }
}
</style>

<script>
import Vue from 'vue'
import _ from 'lodash'
export default {
  name: 'ProductAttribute',
  props: [
    'id',
    'category'
  ],
  data: () => ({
    loading: false,
    saving: false,
    attributeList: [],
    selected: [],
    data: []
  }),
  computed: {},
  methods: {
    formatAttributeName (attribute) {
      return attribute.name.replace(/product.tag./g, '').replace(/-/g, ' ')
    },
    isSelected (attribute) {
      for (var attr of this.selected) {
        if (attr.id === attribute.id) {
          return true
        }
      }

      return false
    },
    toggle (attribute) {
      if (this.id === undefined) {
        this.toggleAttributeAttachment(attribute)
      } else {
        this.toggleAttributeEdit(attribute)
      }
    },
    toggleAttributeAttachment (attribute) {
      if (this.isSelected(attribute)) {
        this.data.splice(
          this.data.findIndex(row => row.id === attribute.id),
          1
        )
      } else {
        this.data.push({ tag_id: attribute.id })
      }
      this.$emit('attribute-selected', this.data)
    },
    toggleAttributeEdit (attribute) {
      if (this.isSelected(attribute)) {
        Vue.$api.delete('/product/' + this.id + '/category-attribute/' + attribute.category_attribute_id, {}, {
          loader: toggle => this.loading = toggle,
          callback: () => this.load()
        })
      } else {
        Vue.$api.post('/product/' + this.id + '/category-attribute/' + attribute.category_attribute_id, {}, {
          loader: toggle => this.loading = toggle,
          callback: () => this.load()
        })
      }
    },
    loadProductCategoryAttributes (productId) {
      Vue.api.get('/product/' + productId + '/attributes', {}, {
        callback: data => {
          this.selected = this.formatAttributes(data.data)
        }
      })
    },
    formatAttributes (data) {
      const attr = []
      _.each(data, (item, index) => {
        _.each(item.attributes, (attribute, index2) => {
          attr.push({ id: attribute.id, product_attribute_id: attribute.product_attribute_id })
        })
      })
      return attr
    },
    loadCategoryAttributes (category, forceLoad) {
      if (category === null) {
        return;
      }
      if (_.isEmpty(this.attributeList) || (undefined !== forceLoad && forceLoad)) {
        this.attributeList = []
        Vue.api.get('/product/category/' + category + '/attributes', {}, {
          callback: data => {
            _.each(data.data, (item) => {
              this.attributeList.push(item)
            })
            this.loadProductCategoryAttributes(this.id)
          }
        })
      } else {
        this.loadProductCategoryAttributes(this.id)
      }
    },
    load () {
      if (this.id !== undefined) {
        this.loadCategoryAttributes(this.category)
      }
    }
  },
  watch: {
    category () {
      if (_.isInteger(this.category)) {
        this.loadCategoryAttributes(this.category, true)
      }
    }
  },
  created () {
    this.loadCategoryAttributes(this.category)
  }
}
</script>

<style scoped>

</style>
